import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import realizationPlanInfo from '../../fragments/realizationPlan/realizationPlanInfo';
export const getDailyRealizationByGroupsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetDailyRealizationByGroups($userId: ID, $date: String) {\n    dailyRealizationByGroups(userId: $userId, date: $date) {\n      ...realizationPlanInfo\n    }\n  }\n  ", "\n"])), realizationPlanInfo);
export const getDailyRealizationByGroupsQueryOptions = variables => ({
  variables,
  fetchPolicy: 'no-cache'
});